/** @format */
import {
    Heading1,
    Heading2,
    Heading3,
    Heading4,
    Heading5,
} from '@contentful/rich-text-types';
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import React, { ReactNode } from 'react';

export const ContentfulHeadingH1 = (props: Heading1, children: ReactNode) => {
    return <Heading size={HeadingSize.H1}>{children}</Heading>;
};

export const ContentfulHeadingH2 = (props: Heading2, children: ReactNode) => {
    return <Heading size={HeadingSize.H2}>{children}</Heading>;
};

export const ContentfulHeadingH3 = (props: Heading3, children: ReactNode) => {
    return <Heading size={HeadingSize.H3}>{children}</Heading>;
};

export const ContentfulHeadingH4 = (props: Heading4, children: ReactNode) => {
    return <Heading size={HeadingSize.H4}>{children}</Heading>;
};

export const ContentfulHeadingH5 = (props: Heading5, children: ReactNode) => {
    return <Heading size={HeadingSize.H5}>{children}</Heading>;
};
